import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const RefundPolicyPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="refund-policy-page">
      {/* Header */}
      <section className="py-12 md:py-16 bg-[#2E5C31]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 text-white">
          <Link to="/" className="inline-flex items-center text-white/80 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold font-['Poppins']">Refund & Cancellation Policy</h1>
          <p className="text-gray-200 mt-2">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="policy-content prose prose-lg">
            <h2>Overview</h2>
            <p>
              At DecorVista Landscaping Services, we strive to ensure complete customer satisfaction with every project. This policy outlines our procedures for cancellations and refunds.
            </p>

            <h2>Cancellation by Customer</h2>
            
            <h3>Before Work Begins</h3>
            <ul>
              <li>Cancellations made 7+ days before scheduled start date: Full deposit refund</li>
              <li>Cancellations made 3-7 days before scheduled start date: 75% deposit refund</li>
              <li>Cancellations made less than 3 days before scheduled start date: 50% deposit refund</li>
            </ul>

            <h3>After Work Has Begun</h3>
            <ul>
              <li>You will be charged for all work completed and materials purchased</li>
              <li>Any remaining deposit will be applied to the final invoice</li>
              <li>A detailed invoice will be provided itemizing all charges</li>
            </ul>

            <h2>Cancellation by DecorVista</h2>
            <p>In rare circumstances, we may need to cancel or reschedule your project due to:</p>
            <ul>
              <li>Severe weather conditions</li>
              <li>Safety concerns</li>
              <li>Unforeseen circumstances beyond our control</li>
            </ul>
            <p>In such cases:</p>
            <ul>
              <li>We will notify you as soon as possible</li>
              <li>We will work with you to reschedule at a mutually convenient time</li>
              <li>Full deposit refund if rescheduling is not possible</li>
            </ul>

            <h2>Refund Process</h2>
            <ul>
              <li>Refund requests must be submitted in writing via email or mail</li>
              <li>Refunds will be processed within 10-14 business days</li>
              <li>Refunds will be issued using the original payment method</li>
              <li>Bank processing times may vary</li>
            </ul>

            <h2>Project Modifications</h2>
            <p>If you wish to modify the scope of work after the project has begun:</p>
            <ul>
              <li>Changes must be requested in writing</li>
              <li>A revised estimate will be provided for approval</li>
              <li>Additional deposits may be required for scope increases</li>
              <li>Credits will be applied for scope reductions</li>
            </ul>

            <h2>Satisfaction Guarantee</h2>
            <p>We stand behind our work. If you are not satisfied with any aspect of our service:</p>
            <ul>
              <li>Contact us within 7 days of project completion</li>
              <li>We will assess the concern and work to resolve it</li>
              <li>Re-work will be performed at no additional cost for valid warranty claims</li>
            </ul>

            <h2>Non-Refundable Items</h2>
            <p>The following are generally non-refundable:</p>
            <ul>
              <li>Custom-ordered materials specific to your project</li>
              <li>Plants and living materials once installed</li>
              <li>Consultation fees (if applicable)</li>
            </ul>

            <h2>How to Request a Cancellation or Refund</h2>
            <p>To request a cancellation or refund, please contact us:</p>
            <ul>
              <li><strong>Email:</strong> support@decorvista.store</li>
              <li><strong>Phone:</strong> +1-888-880-8889</li>
              <li><strong>Mail:</strong> 667 Harbor View Drive, Seattle, WA 98101</li>
            </ul>
            <p>Please include your name, contact information, project details, and reason for cancellation/refund request.</p>

            <h2>Contact Information</h2>
            <ul>
              <li><strong>Business Name:</strong> DecorVista Landscaping Services</li>
              <li><strong>Address:</strong> 667 Harbor View Drive, Seattle, WA 98101</li>
              <li><strong>Phone:</strong> +1-888-880-8889</li>
              <li><strong>Email:</strong> support@decorvista.store</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicyPage;
